var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"id":"Layer_1","height":_vm.height,"width":_vm.height,"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}},[_c('path',{attrs:{"fill":"none","d":"M0,0H48V48H0Z"}}),_c('path',{attrs:{"fill":"#799cfb","d":"M40,8H8a4,4,0,0,0-4,4L4,36a4,4,0,0,0,4,4H40a4,4,0,0,0,4-4V12A4,4,0,0,0,40,8Zm0,8L24,26,8,16V12L24,22,40,12Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }